// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-029465af] .dx-menu-item-content {\n  display: flex;\n  align-items: center;\n}\n[data-v-029465af] .dx-row-removed > td {\n  background-color: white;\n  text-decoration: line-through;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
